import React, { useCallback } from 'react'
import Button from '@mui/material/Button'
import { Grid } from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'
import DateRangePicker from '../../../../../../../components/DateRangePicker'
import ClearIcon from '@mui/icons-material/Clear'
import dayjs from 'dayjs'

export interface IFilterMapped {
  startDate?: string;
  endDate?: string;
}

interface FilterProps {
  filter: IFilterMapped
  onFilterChange: (filter: IFilterMapped) => void;
  onSearch: (filter: IFilterMapped) => void;
}

const LeadListNotificationFilter = ({ onFilterChange, filter, onSearch }: FilterProps) => {
  const { startDate, endDate } = filter

  const handleFilterChange = useCallback((newFilter: IFilterMapped) => {
    onFilterChange({ ...filter, ...newFilter })
  }, [filter, onFilterChange])

  const handleReset = useCallback(() => {
    onFilterChange({
      startDate: dayjs().subtract(30, 'days').format(),
      endDate: dayjs().format()
    })

    onSearch({
      startDate: dayjs().subtract(30, 'days').format(),
      endDate: dayjs().format()
    })
  }, [startDate, endDate, onFilterChange, onSearch])

  return (
    <Grid container spacing={2} mb={2}>
      <Grid item xs={12} lg={7}>
        <DateRangePicker
          disableFuture={false}
          startDate={startDate}
          endDate={endDate}
          onChange={(startDate, endDate) => {
            handleFilterChange({ startDate, endDate })
          }}
        />
      </Grid>
      <Grid item xs={8} lg={4}>
        <Button
          color="primary"
          size={'large'}
          fullWidth
          variant="contained"
          startIcon={<SearchIcon />}
          onClick={() => onSearch(filter)}
          sx={{ height: '100%' }}
        >
          ค้นหา
        </Button>
      </Grid>
      <Grid item xs={4} lg={1}>
        <Button
          color="inherit"
          size="large"
          fullWidth
          variant="contained"
          startIcon={<ClearIcon />}
          onClick={() => handleReset()}
          sx={{ height: '100%' }}
        >
          รีเซ็ต
        </Button>
      </Grid>
    </Grid>
  )
}

export default LeadListNotificationFilter